import {GetTelehealthDocsParams} from 'domain/usecases';
import {makeGetAppointmentsTelehealthDocs} from 'main/factories/usecases';

export const getAppointmentsTelehealthDocs = async (params: GetTelehealthDocsParams) =>
	makeGetAppointmentsTelehealthDocs().get(params);
